// extracted by mini-css-extract-plugin
export default {"successMessage":"styles_successMessage__qfHAQ","progressMessage":"styles_progressMessage__vehYa","loader":"styles_loader__Oh-F1"};